// Live cursor on an entry's DOM: move the cursor line on each bar and profile, bold
// the section or point pair under it, mark the lanes stretch. Nothing is re-rendered.

/**
 * @param {Element} element a `tbody.fe-entry`
 * @param {ReturnType<import("./liveCursor.mjs").cursorTargets>} targets
 */
export function applyCursor(element, targets) {
  const blocks = new Map(
    [...element.querySelectorAll("tr.fe-lrblock")].map((b) => [
      b.dataset.rawKey,
      b,
    ]),
  );
  targets.tags.forEach((t) => {
    const block = blocks.get(t.rawKey);
    if (!block) return;
    const track = block.querySelector(".fe-bar, .fe-profile");
    if (track) {
      let cursor = [...track.children].find((c) =>
        c.classList.contains("fe-cursor"),
      );
      if (!cursor) {
        cursor = element.ownerDocument.createElement("i");
        cursor.className = "fe-cursor";
        track.append(cursor);
      }
      cursor.style.display = "";
      cursor.style.left = `${t.percent}%`;
    }
    block
      .querySelectorAll(".fe-at")
      .forEach((n) => n.classList.remove("fe-at"));
    [t.activeIndex, t.nextIndex]
      .filter((i) => i >= 0)
      .forEach((i) =>
        block
          .querySelectorAll(`[data-index="${i}"]`)
          .forEach((n) => n.classList.add("fe-at")),
      );
  });
  element
    .querySelectorAll(".fe-ls")
    .forEach((n) =>
      n.classList.toggle(
        "fe-at",
        Number(n.dataset.index) === targets.laneStretch,
      ),
    );
}

/** @param {Element} element */
export function clearCursor(element) {
  element
    .querySelectorAll(".fe-cursor")
    .forEach((c) => (c.style.display = "none"));
  element
    .querySelectorAll(".fe-at")
    .forEach((n) => n.classList.remove("fe-at"));
}
